import { render, staticRenderFns } from "./TokenHistoryResult.vue?vue&type=template&id=50f77400&scoped=true"
import script from "./TokenHistoryResult.vue?vue&type=script&lang=js"
export * from "./TokenHistoryResult.vue?vue&type=script&lang=js"
import style0 from "./TokenHistoryResult.vue?vue&type=style&index=0&id=50f77400&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f77400",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f77400')) {
      api.createRecord('50f77400', component.options)
    } else {
      api.reload('50f77400', component.options)
    }
    module.hot.accept("./TokenHistoryResult.vue?vue&type=template&id=50f77400&scoped=true", function () {
      api.rerender('50f77400', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/components/TokenHistoryResult.vue"
export default component.exports